export default __webpack_public_path__ + "static/media/Lucy 9781843629597.787dfda2.jpg";